var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{ref:"searchBrand",attrs:{"id":"searchBrand"}},[_c('GarageBrand',{attrs:{"brand_name":_vm.brand,"brand_id":_vm.carBrandId,"color_kv":_vm.color}}),_vm._v(" "),_c('div',{attrs:{"hidden":""}},[_vm._v("VOLKSWAGEN Pre-owned Cars")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c4b6684","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Volkswagen.vue
// module id = null
// module chunks = 